import { isEmpty } from 'lodash/fp';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import { useGetApplicationQuery } from '../../../api/queries/getApplication';
import { ApplicationStage } from '../../../api/types';
import { ApplicationDetailsExtraContext } from '../../../components/contexts/ApplicationDetailsExtraContext';
import LoadingElement from '../../../components/LoadingElement';
import { useThemeComponents } from '../../../themes';
import { getApplicationPageElement } from '../../portal/ApplicationListEndpoint/ApplicationDetailsPage';
import NotFoundPage from '../../portal/NotFoundPage';

const MobilityBookingDetailsPage = () => {
    const { PageWithHeader } = useThemeComponents();
    const { id } = useParams<{ id: string }>();

    const { data, loading, refetch } = useGetApplicationQuery({ variables: { id } });
    const application = data?.application;

    const navigate = useNavigate();
    const { t } = useTranslation();

    const extra = useMemo(() => ({ application, refetch }), [application, refetch]);

    if (loading) {
        return <LoadingElement />;
    }

    if (isEmpty(application) || application.__typename !== 'MobilityApplication') {
        return <NotFoundPage />;
    }

    return (
        <ApplicationDetailsExtraContext.Provider value={extra}>
            <PageWithHeader
                onBack={() => navigate(-1)}
                title={t('applicationDetails:titles.mobilityBooking', { id: application.mobilityStage?.identifier })}
            >
                {getApplicationPageElement(application, ApplicationStage.Mobility)}
            </PageWithHeader>
        </ApplicationDetailsExtraContext.Provider>
    );
};

export default MobilityBookingDetailsPage;
